import store from '@/store';
import { showNotification } from '@/plugins/notification';

export async function authErrorHandler (error) {
  if(error === 401 || error === 403) {
    showNotification('error', `Error ${error}`,
      error === 401 ? 'Session expired. Please log in to continue.'
      : 'This account no longer exists. Contact support for help, or log out to return to the home screen.', 5000);
    store.dispatch('logOut', error);
  }
}